'use client';

export default function StatCard({ number, label, icon: Icon }) {
  return (
    <div className="text-center text-white group transform hover:scale-102 transition-all duration-300 hover:-translate-y-1">

      <div className="flex justify-center mb-3 sm:mb-4">
        <Icon size={36} className="sm:w-12 sm:h-12 group-hover:scale-110 transition-transform duration-300" />
      </div>


      <h3 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black mb-1 sm:mb-2 group-hover:scale-105 transition-transform duration-300">
        {number}
      </h3>


      <p className="text-white/90 font-semibold text-xs sm:text-sm lg:text-base xl:text-lg">{label}</p>


      <div className="w-0 h-1 bg-white group-hover:w-8 sm:group-hover:w-12 transition-all duration-300 mx-auto mt-2 sm:mt-4"></div>
    </div>
  );
}
